"use strict";var t=require("styled-components").css`
    position: relative;
    width: ${({fullwidth:t})=>t?"100%":"auto"};

    .DXTextInput-dropdownIcon {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 10px;
        margin: auto;
        pointer-events: none;
        z-index: 9;
    }

    .DXTextInput-inputWrap {
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .DXTextInput-label {
        position: absolute;
        top: ${({compact:t})=>t?"10px":"15px"};
        left: 10px;
        margin: auto;
        pointer-events: none;
        transition: transform 0.2s;
        transform-origin: 0;
    }

    input:not([disabled]):focus + .DXTextInput-label,
    input:not([disabled]):active + .DXTextInput-label,
    textarea:not([disabled]):focus + .DXTextInput-label,
    textarea:not([disabled]):active + .DXTextInput-label,
    .DXTextInput-label.valid {
        ${({compact:t})=>t?"visibility: hidden;":"transform: scale(0.7) translateY(-17px)"};
        color: ${({color:t,theme:e})=>t||e.colors.primary.default};
    }

    .DXTextInput-input,
    .DXTextInput-textarea {
        background-color: ${({theme:t,variant:e})=>"fill"===e?t.colors.grey[200]:"transparent"};
        border: ${({theme:t,variant:e})=>"outline"===e?`1.5px solid ${t.colors.grey[500]}`:"none"};
        border-bottom: ${({theme:t,variant:e})=>("fill"===e||"flat"===e)&&`2px solid ${t.colors.grey[500]}`};
        border-radius: ${({variant:t})=>"fill"===t||"flat"===t?"0px":"3px"};
        outline: 0;
    }

    .DXTextInput-input {
        height: ${({compact:t})=>t?"42px":"50px"};
        padding: ${({compact:t})=>t?"0px 10px 0px 10px":"10px 10px 0px 10px"};
        width: ${({compact:t})=>"192px"};
        min-width: ${({fullwidth:t})=>t?"100%":"none"};
        max-width: 100%;
    }

    .DXTextInput-textarea {
        padding: ${({compact:t})=>t?"15px 10px 0px 10px":"25px 10px 0px 10px"};
        width: ${({fullwidth:t})=>t?"100%":"276px"};
        max-width: 100%;
    }

    &.DXTextInput-no-label .DXTextInput-input {
        padding: 0px 10px 0px 10px;
        height: ${({compact:t})=>t?"32px":"50px"};
    }

    input:focus,
    input:active,
    textarea:focus,
    textarea:active {
        border-color: ${({theme:t,color:e})=>e||t.colors.primary.default};
    }

    textarea {
        resize: none;
        height: ${({compact:t})=>t?"74px":"88px"};
        width: ${({compact:t})=>t?"156px":"276px"};
        font-family: 'source-sans-pro';
    }

    input,
    textarea {
        box-sizing: border-box;
    }

    input:disabled + .DXTextInput-label,
    textarea:disabled + .DXTextInput-label {
        cursor: not-allowed;
        color: ${({theme:t})=>t.colors.grey[300]};
    }

    input:disabled,
    textarea:disabled {
        cursor: not-allowed;
        border-color: ${({theme:t})=>t.colors.grey[300]};
    }

    .DXTextInput-note.error,
    .DXTextInput-label.error {
        color: #b21f28;
    }

    .DXTextInput-input.error,
    .DXTextInput-textarea.error {
        border-color: #b21f28;
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
